<template>
  <div>
    <a-modal v-model="visible" :title="title" @ok="handleOk" @cancel="close">
      <a-form-model ref="refForm" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="字段所属" prop="data_type">
          <a-select disabled v-model="form.data_type" allowClear show-search option-filter-prop="children" placeholder="请选择字段所属" style="width: 100%">
            <a-select-option v-for="item in TEMPLATE_TYPE" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="字段标识" prop="field">
          <a-input v-model="form.field" :disabled="isEdit" allowClear :maxLength="30" placeholder="支持英文、下划线，不超过30个字" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="字段名称" prop="field_name">
          <a-input v-model="form.field_name" allowClear :maxLength="10" placeholder="不超过10个字" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item label="字段类型" prop="field_type">
          <a-select v-model="form.field_type" :disabled="isEdit" allowClear show-search @change="changeType" option-filter-prop="children" placeholder="请选择字段类型" style="width: 100%"><a-select-option v-for="item in FIELDS_TYPE" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
          </a-select>
          <div v-if="fieldsTips" class="type-notice">{{ fieldsTips }}</div>
        </a-form-model-item>
        <!-- 单选 、多选-->
        <div class="options-wrapper">
          <a-form-model-item v-if="['radio', 'checkbox'].includes(form.field_type)" class="type-select-item" v-for="(item, index) in form.field_value" :key="index" label="选项值" :prop="`field_value.${index}.value`" :rules="{ required: true, message: '必填！', trigger: 'blur' }"> <a-input v-model="item.value" allowClear :maxLength="10" placeholder="不超过10字" style="width: 100%" /> <a-button type="link" size="small" :disabled="form.field_value.length < 2" @click="deleteSelectOption(index)">删除</a-button> <a-button type="link" size="small" v-show="form.field_value.length != 20" :disabled="form.field_value.length == 20" @click="addSelectOption">新增</a-button>
          </a-form-model-item>
        </div>
        <!-- 图片 -->
        <a-form-model-item v-if="form.field_type === 'upload'" v-for="(item, index) in form.field_value" :key="index" label="图片张数" :prop="`field_value.${index}.pic_num`" :rules="{ required: true, message: '必填！', trigger: 'blur' }">
          <a-input-number v-model="item.pic_num" :min="1" :max="10" placeholder="至少1张，最多10张" style="width: 100%" />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="close">取 消</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk">确 定</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import api from '@/api/'
import compuedFun from '../../computed/'
import { mapState, mapGetters } from 'vuex'
import { fieldTypeDescMapping } from './business/constantsList'
import { cloneDeep } from 'lodash'

const resetForm = () => {
  return {
    id: undefined,
    // sign: undefined,
    field: undefined,
    data_type: undefined,
    field_name: undefined,
    field_type: undefined,
    field_value: []
  }
}
export default {
  props: {
    activeTab: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    const validateSign = (rule, val, callback) => {
      if (val && !/^[a-zA-Z_]{1,}$/.test(val)) {
        callback(new Error('格式错误，只能由下划线和英文组成'))
      } else {
        callback()
      }
    }
    return {
      compuedFun,
      visible: false,
      title: '新增',
      form: resetForm(),
      rules: {
        data_type: [{ required: true, message: '字段所属必填！', trigger: ['blur', 'change'] }],
        field: [
          { required: true, message: '字段标识必填！', trigger: ['blur', 'change'] },
          { validator: validateSign, trigger: ['blur', 'change'] }
        ],
        field_name: [{ required: true, message: '字段名称必填！', trigger: ['blur', 'change'] }],
        field_type: [{ required: true, message: '字段类型必填！', trigger: ['blur', 'change'] }]
      },
      loading: false,
      typeNotices: fieldTypeDescMapping
    }
  },

  computed: {
    ...mapState(['label']),
    fieldsTips() {
      return this.typeNotices?.[this.form.field_type]
    },
    // 字段类型
    FIELDS_TYPE() {
      return this.label.data.FIELD?.FIELDS_TYPE
    },
    // 所属字段
    TEMPLATE_TYPE() {
      return this.label.data.TEMPLATE_MANAGEMENT?.TEMPLATE_TYPE
    },
    // 模板状态
    TEMPLATE_STATE() {
      return this.label.data.TEMPLATE_MANAGEMENT?.TEMPLATE_STATE
    },
    isEdit() {
      return !!this.form.id
    }
  },

  methods: {
    open(row) {
      this.form.id = undefined
      if (row && row.constructor === Object) {
        const record = cloneDeep(row)
        for (const key in this.form) {
          if (record[key]) this.form[key] = record[key]
        }
        this.form.id = record.id
      }
      this.form.data_type = Number(this.activeTab)
      this.visible = true
    },
    close() {
      this.form = resetForm()
      this.$refs.refForm.resetFields()
      this.visible = false
    },
    handleOk() {
      this.$refs.refForm.validate(valid => {
        if (valid) {
          const postParams = { ...this.form }
          if (!['radio', 'checkbox', 'upload'].includes(this.form.field_type)) {
            delete postParams.field_value
          }
          this.loading = true
          const requestAction = this.form.id ? api.updateFields(this.form) : api.createFields(this.form)
          requestAction
            .then(res => {
              if (res.code === '000000') {
                this.$emit('ok')
                this.close()
                this.$message.success('操作成功')
              }
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$message.warning('请检查必填项！')
        }
      })
    },
    changeType() {
      if (['radio', 'checkbox'].includes(this.form.field_type)) {
        this.form.field_value = [{ value: '' }]
      } else if (this.form.field_type === 'upload') {
        this.form.field_value = [{ pic_num: 1 }]
      } else {
        this.form.field_value = []
      }
    },
    deleteSelectOption(idx) {
      this.form.field_value.splice(idx, 1)
    },
    addSelectOption() {
      if (this.form.field_value.length < 20) {
        this.form.field_value.push({ value: '' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.options-wrapper {
  max-height: 450px;
  overflow-y: auto;
}

.type-notice {
  font-size: 12px;
  color: #777;
  line-height: 20px;
}

.type-select-item {
  margin-left: 68px;
  margin-bottom: 12px;

  /deep/.ant-form-item-children {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }
}
</style>
